window.axios.interceptors.response.use(function (response)  {
    return response;
}, function (error) {
    if (error.response && error.response.status === 401) {
        window.location.href = route('login');
        return;
    }

    return Promise.reject(error);
});